"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PageButton = _interopRequireDefault(require("./PageButton"));

var Const = _interopRequireWildcard(require("./PaginationConstants"));

var _utils = require("../utils/utils");

var _DropdownMenu = _interopRequireDefault(require("../DropdownMenu/DropdownMenu"));

require("./Pagination.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var lastId = 0;

var Pagination = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Pagination, _Component);

  var _super = _createSuper(Pagination);

  function Pagination(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Pagination);
    _this = _super.call(this, props);
    _this.handleChangePage = _this.handleChangePage.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChangePageSize = _this.handleChangePageSize.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Pagination, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      lastId++;
      this.id = lastId;
    }
  }, {
    key: "handleChangePage",
    value: function handleChangePage(page) {
      var _this$props = this.props,
          pageStartIndex = _this$props.pageStartIndex,
          prePage = _this$props.prePage,
          currentPage = _this$props.currentPage,
          nextPage = _this$props.nextPage,
          lastPage = _this$props.lastPage,
          firstPage = _this$props.firstPage,
          pageSize = _this$props.pageSize;

      if (page === prePage || page === Const.DEFAULT_PRE_PAGE) {
        page = currentPage - 1 < pageStartIndex ? pageStartIndex : currentPage - 1;
      } else if (page === nextPage || page === Const.DEFAULT_NEXT_PAGE) {
        page = currentPage + 1 > this.lastPage ? this.lastPage : currentPage + 1;
      } else if (page === lastPage) {
        page = this.lastPage;
      } else if (page === firstPage) {
        page = pageStartIndex;
      } else if (page === Const.PAGE_SKIP) {
        return;
      } else {
        page = parseInt(page, 10);
      }

      if (page !== currentPage) {
        this.props.onChangePage(page, pageSize);
      }
    }
  }, {
    key: "handleChangePageSize",
    value: function handleChangePageSize(e) {
      e.preventDefault();
      var selectSize = parseInt(e.currentTarget.text, 10);
      var currentPage = this.props.currentPage;

      if (selectSize !== this.props.pageSize) {
        // figure out the current offset, so after changing page size, the first result that was on the previous
        // page size is still the first result
        var currOffset = this.props.pageSize * (currentPage - this.props.pageStartIndex);
        currentPage = Math.max(Math.ceil(currOffset / selectSize) + this.props.pageStartIndex, this.props.pageStartIndex);
        this.totalPages = Math.ceil(this.props.dataSize / selectSize);
        this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
        if (currentPage > this.lastPage) currentPage = this.lastPage;
        this.props.onChangePage(currentPage, selectSize);
        this.props.onChangePageSize(selectSize);
      }
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var _this$props2 = this.props,
          currentPage = _this$props2.currentPage,
          dataSize = _this$props2.dataSize,
          pageSize = _this$props2.pageSize,
          resultsSummary = _this$props2.resultsSummary,
          pageStartIndex = _this$props2.pageStartIndex;
      var offset = Math.abs(Const.PAGE_START_INDEX - pageStartIndex);
      var start = (currentPage - pageStartIndex) * pageSize;
      var to = Math.min(pageSize * (currentPage + offset) - 1, dataSize - 1);
      var resultsText = resultsSummary && typeof resultsSummary === 'function' ? resultsSummary(start, to, dataSize) : null;
      var paginationContent = null;

      if (pageSize < dataSize) {
        var pageButtons = this.makePage();
        paginationContent = /*#__PURE__*/_react.default.createElement("div", {
          className: "text-center pagination-wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "clearfix results-text"
        }, resultsText), /*#__PURE__*/_react.default.createElement("ul", {
          className: "pagination"
        }, pageButtons));
      }

      return paginationContent;
    }
  }, {
    key: "renderItemPerPageCount",
    value: function renderItemPerPageCount() {
      var _this2 = this;

      var _this$props3 = this.props,
          pageSize = _this$props3.pageSize,
          pageSizeList = _this$props3.pageSizeList,
          hideSizePerPage = _this$props3.hideSizePerPage;
      var pageSizeOptions = pageSizeList.map(function (_pageSize) {
        return /*#__PURE__*/_react.default.createElement(_DropdownMenu.default.MenuItem, {
          key: _pageSize,
          onClick: _this2.handleChangePageSize
        }, _pageSize);
      });
      var content = null;

      if (pageSizeList.length > 1 && !hideSizePerPage) {
        content = /*#__PURE__*/_react.default.createElement("div", {
          className: "text-center item-count-wrapper"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "results-text"
        }, "Results per page : "), /*#__PURE__*/_react.default.createElement(_DropdownMenu.default.Dropdown, null, /*#__PURE__*/_react.default.createElement("a", {
          bsRole: "toggle",
          href: "javascript.void(0);",
          onClick: this.showPageCountList.bind(this),
          role: "button",
          className: "dropdown-toggle",
          type: "button",
          id: "paginationPageSize".concat(this.id),
          "data-toggle": "dropdown",
          "aria-expanded": "true"
        }, pageSize, ' ', /*#__PURE__*/_react.default.createElement("span", {
          className: "caret"
        })), /*#__PURE__*/_react.default.createElement(_DropdownMenu.default, {
          "aria-labelledby": "paginationPageSize".concat(this.id)
        }, pageSizeOptions)));
      }

      return content;
    }
  }, {
    key: "showPageCountList",
    value: function showPageCountList(e) {
      e.preventDefault();
      this.setState({
        showPageCountList: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          dataSize = _this$props4.dataSize,
          pageSize = _this$props4.pageSize;
      this.totalPages = Math.ceil(dataSize / pageSize);
      this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "row buffer-top-small primitive-pagination"
      }, this.renderPagination(), this.renderItemPerPageCount());
    }
  }, {
    key: "makePage",
    value: function makePage() {
      var pages = this.getPages();
      return pages.map(function (page, iterator) {
        var isActive = page === this.props.currentPage;
        var plain = page === Const.PAGE_SKIP;
        var disabled = plain || false;

        if (this.props.currentPage === this.props.pageStartIndex && iterator !== pages.length - 1 && (page === this.props.firstPage || page === this.props.prePage || iterator === 0)) {
          disabled = true;
        }

        if (this.props.currentPage === this.lastPage && iterator !== 0 && (page === this.props.nextPage || page === this.props.lastPage || iterator === pages.length - 1)) {
          disabled = true;
        }

        return /*#__PURE__*/_react.default.createElement(_PageButton.default, {
          key: iterator,
          index: iterator,
          pageCount: pages.length,
          onChangePage: this.handleChangePage,
          active: isActive,
          disabled: disabled,
          plain: plain
        }, page);
      }, this);
    }
  }, {
    key: "getPages",
    value: function getPages() {
      var pages;
      if (this.totalPages <= 0) return []; // total pages > total buttons to display (minus the 2 for next/prev)

      var hasSkip = this.totalPages > this.props.paginationSize - 2;
      var hasStartSkip = hasSkip && this.props.currentPage >= Math.ceil(this.props.paginationSize / 2);
      var hasEndSkip = hasSkip && this.props.currentPage <= this.totalPages - Math.floor(this.props.paginationSize / 2); // if there's more than 1 page, then we need to display a last page

      var hasLastPage = this.totalPages > 1; // always add the previous page and first page buttons

      pages = [this.props.prePage, this.props.pageStartIndex]; // ellipsis at beginning

      if (hasStartSkip) {
        pages.push(Const.PAGE_SKIP);
      } // figure out the start and end of the sequential buttons...


      var min = this.props.pageStartIndex + 1 + (hasStartSkip ? 1 : 0);
      var max = this.totalPages - 1 - (hasEndSkip ? 1 : 0);
      var start = min;
      var end = max;

      if (hasSkip) {
        // find the number of buttons that should be in the middle (total number of buttons minus the previous, next, first, last, start skip, and end skip)
        var middleBtnCount = this.props.paginationSize - 6; // start - current page minus half of the middle button count or the second page ... whichever is larger

        start = Math.max(this.props.currentPage - Math.floor(middleBtnCount / 2), min); // end - current page plus half of the middle button count or the second to last page ... whichever is smaller

        end = Math.min(this.props.currentPage + Math.floor(middleBtnCount / 2), max); // if we don't have the start skip (the ellipsis) and the start isn't already the second page then, lets decrement the start

        if (!hasStartSkip && start > min) start--; // if we don't have the end skip (the ellipsis) and the end isn't already the second to last page then, lets increment the end

        if (!hasEndSkip && end < max) end++; // now only need to tweak things if only have a single skip

        if (!(hasStartSkip && hasEndSkip)) {
          // if we're at the beginning then update the end to be start plus the middle button count
          if (start + 1 < middleBtnCount) {
            end = start + middleBtnCount;
          } // if we're at the end then update the start to be end minus the middle button count


          if (end > max - middleBtnCount) {
            start = end - middleBtnCount;
          }
        }
      } // iterate between start and end to add those pages


      for (var i = start; i <= end; i++) {
        pages.push(i);
      } // ellipsis at end


      if (hasEndSkip) {
        pages.push(Const.PAGE_SKIP);
      } // add the last page in all cases except when there are less than 2 pages


      if (hasLastPage) {
        pages.push(this.totalPages);
      } // always add the 'next' button


      pages.push(this.props.nextPage);
      return pages;
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        // the current page to display
        currentPage: _propTypes.default.number,
        // the number of results per page
        pageSize: _propTypes.default.number,
        // the total number of results
        dataSize: _propTypes.default.number,
        // the possible page sizes in the list
        pageSizeList: _propTypes.default.arrayOf(_propTypes.default.number),
        // function to render the results summary
        resultsSummary: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
        // the max total number of buttons to display in the pagination
        paginationSize: _propTypes.default.number,
        // event that is triggered when changing pages (also occurs when changing page size since the page will likely change as well)
        onChangePage: _propTypes.default.func,
        // event that is triggered when changing page size (the onChangePage event will be triggered before this one)
        onChangePageSize: _propTypes.default.func,
        // text to display for the previous button
        prePage: _propTypes.default.string,
        // text to display for the next button
        nextPage: _propTypes.default.string,
        // text to display for the first button
        firstPage: _propTypes.default.string,
        // text to display for the last button
        lastPage: _propTypes.default.string,
        // how page numbering starts (defaults to 1-based numbering, but if using 0-based paging, set this to 0)
        pageStartIndex: _propTypes.default.number,
        // whether or not to hide the size per page option
        hideSizePerPage: _propTypes.default.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        currentPage: 1,
        pageSize: Const.SIZE_PER_PAGE,
        pageStartIndex: Const.PAGE_START_INDEX,
        pageSizeList: Const.SIZE_PER_PAGE_LIST,
        prePage: Const.PRE_PAGE,
        nextPage: Const.NEXT_PAGE,
        firstPage: Const.FIRST_PAGE,
        lastPage: Const.LAST_PAGE,
        paginationSize: Const.PAGINATION_SIZE,
        onChangePage: _utils.noop,
        onChangePageSize: _utils.noop,
        resultsSummary: function resultsSummary(start, to, size) {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "page-size-dropdown",
            tabIndex: "0"
          }, "Showing ", /*#__PURE__*/_react.default.createElement("strong", null, start + 1, "-", to + 1), " of", /*#__PURE__*/_react.default.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: '&nbsp;'
            }
          }), /*#__PURE__*/_react.default.createElement("strong", null, size));
        }
      };
    }
  }]);
  return Pagination;
}(_react.Component);

exports.default = Pagination;